import { render, staticRenderFns } from "./AnalysisTable.vue?vue&type=template&id=2390956f&scoped=true&"
import script from "./AnalysisTable.vue?vue&type=script&lang=js&"
export * from "./AnalysisTable.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisTable.vue?vue&type=style&index=0&id=2390956f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390956f",
  null
  
)

export default component.exports